import { useStore } from '../store';
import { fmtClock, fmtMoney } from '../bridge';
import { IconCoin, IconGear } from './icons';
import { SpeedControl } from './SpeedControl';

export function TopHud() {
  const { sim, setSettingsOpen, setTab } = useStore();
  const openHoldings = () => { setTab('reserve'); window.setTimeout(() => { window.dispatchEvent(new Event('ea:holdings')); }, 60); };
  return (
    <header class="hud">
      <div class="hud-side">
        <button class="hud-cash" aria-label="Holdings" onClick={openHoldings}><span class="coin-medal"><IconCoin /></span>{fmtMoney(sim.cashCents)}</button>
      </div>
      <div class="hud-side">
        <span class="hud-clock">{fmtClock(sim.tick)}</span>
        <SpeedControl />
        <button class="icon-btn" aria-label="Settings" onClick={() => { setSettingsOpen(true); }}>
          <IconGear />
        </button>
      </div>
    </header>
  );
}
